import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';
import {
    BET_PLACEMENT_FROM_SOURCE_SUCCESS_METRIC_KEY,
    BET_PLACEMENT_METRIC_KEY,
    LDFeatureFlags,
    LEGS_PER_MULTI_METRIC_KEY,
    LaunchDarklyTrackingService,
} from '@frontend/sports/launch-darkly/feature';

import { IPlacedBetslipResult } from '../../betplacement/models';
import { isSucceededNonPartialSlip } from '../../betplacement/utils';

@Injectable()
export class BetslipLaunchDarklyTrackingService {
    constructor(private launchDarklyTrackingService: LaunchDarklyTrackingService) {}

    trackSucceededSlips(result: IPlacedBetslipResult): void {
        const slips = result.slips.filter((slip) => isSucceededNonPartialSlip(slip));
        const comboSlip = slips.find((slip) => slip.betType === BetSlipType.Combo);
        const legsPerCombo = comboSlip?.picks.length;

        this.launchDarklyTrackingService.trackByLocalStorage(LDFeatureFlags.DisplayMode, BET_PLACEMENT_METRIC_KEY, slips.length);
        this.launchDarklyTrackingService.trackByLocalStorage(LDFeatureFlags.DisplayMode, LEGS_PER_MULTI_METRIC_KEY, legsPerCombo ?? 0);
    }

    trackIsBetPlacementSucceededFromFavourites(result: IPlacedBetslipResult) {
        const FAVOURITES_TRACKING_SOURCE = 'favourites';
        const succeededResultSlip = result.slips.filter((slip) => isSucceededNonPartialSlip(slip));
        const slipsWithFavouritePick = succeededResultSlip.filter((slip) =>
            slip.picks.some((pick) => pick.clientPick?.tracking.source?.toLowerCase()?.includes(FAVOURITES_TRACKING_SOURCE)),
        );

        if (slipsWithFavouritePick.length > 0) {
            this.launchDarklyTrackingService.trackByContext(
                LDFeatureFlags.FavouritesNavigationMenuPosition,
                BET_PLACEMENT_FROM_SOURCE_SUCCESS_METRIC_KEY,
            );
        }
    }
}
